exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".open[data-v-a7bc1840]{-webkit-box-shadow:0 0 17px 2px rgba(0,0,0,.3);box-shadow:0 0 17px 2px rgba(0,0,0,.3);margin-bottom:30px}.expand-box[data-v-a7bc1840]{width:30px;height:30px;text-align:center;line-height:30px;margin-right:20px}.expand-box svg[data-v-a7bc1840]{-webkit-transform:translateY(1px);transform:translateY(1px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a7bc1840","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./web/app/themes/giles/resources/js/components/Collapsable.vue
// module id = 424
// module chunks = 0